export enum TokenExchangeTypes {
  TOKEN_EXCHANGE_REQUEST = 'TOKEN_EXCHANGE_REQUEST',
  TOKEN_EXCHANGE_RESPONSE = 'TOKEN_EXCHANGE_RESPONSE',
  TOKEN_EXCHANGE_SIGNOUT = 'TOKEN_EXCHANGE_SIGNOUT',
  TOKEN_EXCHANGE_SIGNOUT_ERROR = 'TOKEN_EXCHANGE_SIGNOUT_ERROR',
  TOKEN_EXCHANGE_ERROR = 'TOKEN_EXCHANGE_ERROR',
}
